import React, { useContext, useState } from 'react';
import classes from './Footer.module.css';
import logo from '../assets/logo-monochrome.svg';
import { Link, useLocation } from 'react-router-dom';
import instaLogo from '../assets/instagram.svg';
import tiktokLogo from '../assets/icon_tiktok.svg';
import fbLogo from '../assets/facebook-logo-button.svg';
import discordLogo from '../assets/discord.svg';
import ldLogo from '../assets/linkedin.svg';
// Needed for Language Switcher
// ==============================================================================================
import arrowDown from '../assets/arrow.svg';
// import { useState } from 'react';
import { LanguageContext } from '../providers/LanguageProvider';
import { useEffect } from 'react';

const Footer = (): JSX.Element => {
  const [isActive, setIsActive] = useState(false);
  const disableLink = () => {
    setIsActive(!isActive);
    return isActive ? classes.disabledLink : '';
  };

  const path = useLocation().pathname;
  // Language Switcher
  // ==============================================================================================
  const { lang, saveLang } = useContext(LanguageContext);
  const [language, setLanguage] = useState(lang);

  useEffect(() => {
    saveLang(language);
  }, []);

  const handleLanguage = (language: any) => {
    setLanguage(language);
    saveLang(language);
  };

  return (
    <footer className={classes.footerContainer}>
      <div className={classes.info}>
        <div className={classes.links}>
          <Link className={path === '/mobile-app' ? classes.active : ''} style={{ marginLeft: '0' }} to='/mobile-app'>
            ÜBER SQUIB
          </Link>
          <Link className={path === '/blog' ? 'active' : ''} to='/blog'>
            BLOG
          </Link>
          <Link className={path === '/kontakt' ? 'active' : ''} to='/kontakt'>
            KONTAKT
          </Link>
          <Link className={path === '/jobs' ? classes.active : ''} to='/jobs'>
            JOBS
          </Link>
          <Link className={path === '/media' ? classes.active : ''} to='/media'>
            MEDIEN
          </Link>
          <Link className={path === '/impressum-datenschutz' ? classes.active : ''} to='/impressum-datenschutz'>
            IMPRESSUM
          </Link>
        </div>
        <div className={classes.verticalLine}></div>
        <div className={classes.social}>
          <a href='https://www.instagram.com/squib.app/' target='_blank' rel='noreferrer'>
            <img style={{ marginLeft: '0' }} src={instaLogo} alt='insta-logo' />
          </a>

          <a href='https://www.tiktok.com/@squib.app' target='_blank' rel='noreferrer'>
            <img src={tiktokLogo} alt='fb-logo' />
          </a>

          <a href='https://www.facebook.com/Squib-375471659967645' target='_blank' rel='noreferrer'>
            <img src={fbLogo} alt='fb-logo' />
          </a>

          <a href='https://discord.gg/V6N7YNrHXV' target='_blank' rel='noreferrer'>
            <img src={discordLogo} alt='discord-logo' />
          </a>

          <a href='https://www.linkedin.com/company/squib-solutions' target='_blank' rel='noreferrer'>
            <img src={ldLogo} alt='linkedin-logo' />
          </a>
        </div>
        {/* Language Switcher ============================================================================================== */}
        {/* <select
          className={classes.languageContainer}
          name='language'
          value={language}
          onChange={event => handleLanguage(event.target.value)}
        >
          <option id='0' value='de'>
            DEUTSCH
          </option>
          <option id='1' value='en'>
            ENGLISH
          </option>
        </select> */}
      </div>
      <div className={classes.policy}>
        <p>
          <span className={classes.ltd}>© 2022 Squib Ltd.</span> <br className={classes.breakVisible} hidden />
          Squib ist eine urheberrechtlich geschützte Marke von Squib Ltd. Alle Rechte vorbehalten. Alle anderen Marken sind Eigentum der
          jeweiligen Inhaber.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
